import type { WidgetItem } from '../../../domain/company_widgets';
import CompanyWidgetsService from '../../../services/companyWidgets';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

const WIDGET_TRACKING_NAME_MAP = {
  overview: 'Overview',
  firmographics: 'Company Data',
  signals: 'Signals feed',
  salesforceActivity: 'Salesforce Activity',
  trafficVisits: 'Traffic Over Time',
  engagement: 'Avg. Monthly Engagement',
  trafficShare: 'Traffic Share',
  ecommerce: 'Ecommerce Overview',
  adNetworks: 'Ad Network',
  technologies: 'Technologies',
};

export const useWidgetPickerTracking = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleTracking = (action: string, eventName: string) => {
    dispatchTrackEventWithLocation('company data', action, eventName);
  };

  const trackOpenWidgetPicker = () => {
    handleTracking('open widget picker', 'change widgets');
  };

  const trackChangeWidgets = (widgets: WidgetItem[]) => {
    const selectedWidgets = CompanyWidgetsService.getSelectedWidgetsIds(widgets);
    handleTracking('change widgets', `save changes/${selectedWidgets.length}`);
  };

  const trackClickOnCheckbox = (updatedWidget: WidgetItem, widgets: WidgetItem[]) => {
    const selectedWidgets = CompanyWidgetsService.getSelectedWidgetsIds(widgets);
    handleTracking(
      updatedWidget.isChecked ? 'add widget' : 'remove widget',
      `${WIDGET_TRACKING_NAME_MAP[updatedWidget.id]}/${selectedWidgets.length}`
    );
  };

  const trackHoverWidget = (widget: keyof typeof WIDGET_TRACKING_NAME_MAP) => {
    handleTracking('hover widget', `${WIDGET_TRACKING_NAME_MAP[widget]}`);
  };

  return {
    trackOpenWidgetPicker,
    trackChangeWidgets,
    trackClickOnCheckbox,
    trackHoverWidget,
  };
};
